import banner from "./banner.webp"
import logo from "./logo.jpeg"

const shop = {
    id: "shop010",
  
    vendorId: "hbejOmKzT1VXoY8Zb6AzqyBqjTh1",
  
    slug: "burger-king-ph",
  
    name: "Burger King",
  
    category: "food",
  
    rating: 4.5,
  
    deliveryTime: "20-30 mins",
  
    featured: true,
  
    logo: logo,
  
    banner: banner,

    size: "large",

    products: [],

    location: "Port Harcourt",

    deliveryPricing: {
      baseFee: 500,
      perKm: 180
    },

    location2: {
      area: "Wuse 2",
      city: "Abuja",
    
      coordinates: {
        lat: 9.0765,
        lng: 7.3986
      }
    },
   
  };
  
  export default shop;